import BaseData from './base-data'
export * from './base-data'
export default BaseData
